export default "__VITE_ASSET__TkwpJZ0V__"